import React from "react";
import { Box, Typography } from "@mui/material";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import "./FixtureStyles.scss";

interface FixturesPlaceholderProps {
  message: string;
  icon?: React.ReactNode;
}

/** Centered empty-state shown when a fixtures list has nothing to display. */
const FixturesPlaceholder: React.FC<FixturesPlaceholderProps> = ({
  message,
  icon,
}) => (
  <Box className="fixturesPlaceholder">
    {icon ?? <EventBusyOutlinedIcon className="fixturesPlaceholder__icon" />}
    <Typography className="fixturesPlaceholder__text">{message}</Typography>
  </Box>
);

export default FixturesPlaceholder;
